
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section with Background Image */}
        <section 
          className="py-16 bg-gray-50 relative bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2832&q=80')`
          }}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">取り扱いサービス</h1>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">車検から修理、鈑金、乗り換えまで、お車に関することなら何でもお任せください。</p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* 車検整備 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1632823471565-1ecdf7a0c8b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="車検整備" 
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">車検整備</h3>
                  <p className="text-gray-600 mb-4">
                    法定点検から車検まで、お客様の大切なお車を安全にお乗りいただけるよう、
                    経験豊富な整備士が丁寧に点検・整備いたします。
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• 法定12ヶ月点検</li>
                    <li>• 法定24ヶ月点検（車検）</li>
                    <li>• 定期点検整備</li>
                    <li>• 予防整備</li>
                  </ul>
                </div>
              </div>

              {/* 鈑金・塗装 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="鈑金・塗装" 
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">鈑金・塗装</h3>
                  <p className="text-gray-600 mb-4">
                    事故や飛び石による傷、へこみなど、お車の外装トラブルを
                    熟練の技術で美しく修復いたします。
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• 事故修理</li>
                    <li>• へこみ修理</li>
                    <li>• 傷修理</li>
                    <li>• 全塗装・部分塗装</li>
                  </ul>
                </div>
              </div>

              {/* 乗り換えサポート */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="乗り換えサポート" 
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">乗り換えサポート</h3>
                  <p className="text-gray-600 mb-4">
                    お客様のライフスタイルに合った最適な車選びから、
                    下取り・買取まで、乗り換えを総合的にサポートします。
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• 車両査定・買取</li>
                    <li>• 新車・中古車販売</li>
                    <li>• 下取りサービス</li>
                    <li>• 乗り換え相談</li>
                  </ul>
                </div>
              </div>

              {/* 一般修理 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1487754180451-c456f719a1fc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="一般修理" 
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">一般修理</h3>
                  <p className="text-gray-600 mb-4">
                    エンジンやブレーキ、エアコンなど、お車の様々なトラブルに
                    迅速かつ的確に対応いたします。
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• エンジン修理</li>
                    <li>• ブレーキ修理</li>
                    <li>• エアコン修理</li>
                    <li>• 電装系修理</li>
                  </ul>
                </div>
              </div>

              {/* タイヤ・ホイール */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="タイヤ・ホイール" 
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">タイヤ・ホイール</h3>
                  <p className="text-gray-600 mb-4">
                    タイヤ交換からホイール修理まで、走行の安全性を支える
                    重要な部品のメンテナンスを行います。
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• タイヤ交換・販売</li>
                    <li>• ホイル修理</li>
                    <li>• パンク修理</li>
                    <li>• ホイールバランス調整</li>
                  </ul>
                </div>
              </div>

              {/* 保険対応 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="保険対応" 
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3">保険対応</h3>
                  <p className="text-gray-600 mb-4">
                    各種保険会社との連携により、事故時の修理から
                    手続きまでワンストップでサポートいたします。
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• 事故対応</li>
                    <li>• 保険手続きサポート</li>
                    <li>• 代車サービス</li>
                    <li>• 損害査定立会い</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-slate-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              お車のことなら何でもご相談ください
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              経験豊富なスタッフが、お客様のお車を大切にメンテナンスいたします
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="/contact" 
                className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </a>
              <a 
                href="tel:0123-45-6789" 
                className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-slate-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                電話で相談
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
